module.exports = __webpack_public_path__ + "static/media/payment-flow-fr.e649be2b.png";